const DISPLAY_CODE_BY_ALIAS: Readonly<Record<string, string>> = {
    agu: 'AGU',
    aguascalientes: 'AGU',
    bc: 'BCN',
    bcn: 'BCN',
    'baja california': 'BCN',
    bcs: 'BCS',
    'baja california sur': 'BCS',
    cam: 'CAM',
    camp: 'CAM',
    campeche: 'CAM',
    chh: 'CHH',
    chih: 'CHH',
    chihuahua: 'CHH',
    chp: 'CHP',
    chis: 'CHP',
    chiapas: 'CHP',
    cdmx: 'CMX',
    cmx: 'CMX',
    df: 'CMX',
    'ciudad de mexico': 'CMX',
    'distrito federal': 'CMX',
    coa: 'COA',
    coah: 'COA',
    coahuila: 'COA',
    'coahuila de zaragoza': 'COA',
    col: 'COL',
    colima: 'COL',
    dgo: 'DUR',
    dur: 'DUR',
    durango: 'DUR',
    gro: 'GRO',
    guerrero: 'GRO',
    gto: 'GUA',
    gua: 'GUA',
    guanajuato: 'GUA',
    hgo: 'HID',
    hid: 'HID',
    hidalgo: 'HID',
    jal: 'JAL',
    jalisco: 'JAL',
    mex: 'MEX',
    mexico: 'MEX',
    'estado de mexico': 'MEX',
    'edo mex': 'MEX',
    mic: 'MIC',
    mich: 'MIC',
    michoacan: 'MIC',
    'michoacan de ocampo': 'MIC',
    mor: 'MOR',
    morelos: 'MOR',
    nay: 'NAY',
    nayarit: 'NAY',
    nl: 'NLE',
    'n l': 'NLE',
    nle: 'NLE',
    'nuevo leon': 'NLE',
    oax: 'OAX',
    oaxaca: 'OAX',
    pue: 'PUE',
    puebla: 'PUE',
    qro: 'QRO',
    que: 'QRO',
    queretaro: 'QRO',
    roo: 'ROO',
    'q roo': 'ROO',
    'quintana roo': 'ROO',
    sin: 'SIN',
    sinaloa: 'SIN',
    slp: 'SLP',
    's l p': 'SLP',
    'san luis potosi': 'SLP',
    son: 'SON',
    sonora: 'SON',
    tab: 'TAB',
    tabasco: 'TAB',
    tam: 'TAM',
    tamps: 'TAM',
    tamaulipas: 'TAM',
    tla: 'TLA',
    tlax: 'TLA',
    tlaxcala: 'TLA',
    ver: 'VER',
    veracruz: 'VER',
    'veracruz de ignacio de la llave': 'VER',
    yuc: 'YUC',
    yucatan: 'YUC',
    zac: 'ZAC',
    zacs: 'ZAC',
    zacatecas: 'ZAC',
};

function normalizeStateAlias(value: string): string {
    return value
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .trim()
        .toLowerCase()
        .replace(/^mx[-_\s]*/, '')
        .replace(/[^a-z0-9]+/g, ' ')
        .replace(/\s+/g, ' ')
        .trim();
}

export function resolveMexicoStateDisplayCode(
    ...candidates: Array<string | null | undefined>
): string | null {
    for (const candidate of candidates) {
        if (!candidate?.trim()) {
            continue;
        }

        const normalizedCandidate = normalizeStateAlias(candidate);
        const displayCode = DISPLAY_CODE_BY_ALIAS[normalizedCandidate];
        if (displayCode) {
            return displayCode;
        }

        const lettersOnly = normalizedCandidate.replace(/[^a-z]/g, '').toUpperCase();
        if (lettersOnly.length === 3) {
            return lettersOnly;
        }
    }

    return null;
}

export function formatAddressWithMexicoStateCode(
    address: string | null | undefined,
    stateCode?: string | null,
    state?: string | null,
): string {
    const normalizedAddress = address?.trim() ?? '';
    if (!normalizedAddress) {
        return '';
    }

    const displayCode = resolveMexicoStateDisplayCode(stateCode, state);
    if (!displayCode) {
        return normalizedAddress;
    }

    const segments = normalizedAddress
        .split(',')
        .map((segment) => segment.trim())
        .filter(Boolean);
    const normalizedState = state?.trim() ? normalizeStateAlias(state) : null;
    const lastSegmentIndex = segments.length - 1;
    const lastSegmentIsCountry = normalizeStateAlias(segments[lastSegmentIndex] ?? '') === 'mexico';
    const lastSearchableIndex = lastSegmentIsCountry ? lastSegmentIndex - 1 : lastSegmentIndex;

    let stateSegmentIndex = -1;
    if (normalizedState) {
        for (let index = lastSearchableIndex; index >= 0; index -= 1) {
            if (normalizeStateAlias(segments[index]) === normalizedState) {
                stateSegmentIndex = index;
                break;
            }
        }
    }

    if (stateSegmentIndex < 0) {
        for (let index = lastSearchableIndex; index >= 0; index -= 1) {
            if (resolveMexicoStateDisplayCode(segments[index]) === displayCode) {
                stateSegmentIndex = index;
                break;
            }
        }
    }

    if (stateSegmentIndex < 0) {
        return normalizedAddress;
    }

    segments[stateSegmentIndex] = displayCode;
    return segments.join(', ');
}
